<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div v-if="$auth.hasPermi('system:talnetContacts:add-edit')">
			<el-radio-group v-model="row.is_add_wx" @change="radioFun(row)">
				<el-radio label="1">是</el-radio>
				<el-radio label="0">否</el-radio>
			</el-radio-group>
		</div>
		<div v-else>
			{{ row.is_add_wx === '1' ? '是' : '否' }}
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { addwxfriend } from '@/api/talentCRM';
export default {
	mixins: [mixin],
	inject: ['refresh'],
	methods: {
		async radioFun(row) {
			const { code } = await addwxfriend({ is_add_wx: row.is_add_wx, contact_id: row.id });
			if (code === 0) {
				this.$message.success('修改成功');
				this.refresh();
			}
		},
	},
};
</script>
<style lang="less" scoped>
</style>
